<template>
  <div>
    <h3>Add New Workload</h3>
    <workload-form @fileAdded="addFile" @fileRemoved="removeFile"></workload-form>
    <div class="text-right mt-2">
      <b-button variant="primary" @click="submitWorkload()">Submit</b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import TimePeriodApi from "../../api/timePeriods";
import WorkloadForm from "../../components/workloads/workload-form";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      employeeJobsInitialized: false,
      workloadTypeDefinitionsInitialized: false,
      timePeriodInitialized: false,
    };
  },

  props: {
    timePeriod: {
      required: false,
    },
    asurite: {
      required: false,
      type: String,
      default: null,
    },
  },

  components: {
    "workload-form": WorkloadForm,
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      employeeJobs: (state) => state.workloadForm.employeeJobs,
      currentTimePeriod: (state) => state.status.currentTimePeriod,
      workload: (state) => state.workloadForm.workload,
    }),
    submittingOnBehalf: function() {
      return this.asurite && this.asurite !== this.user.userId;
    },

    callsCompleted: function() {
      return (
        this.employeeJobsInitialized &&
        this.workloadTypeDefinitionsInitialized &&
        this.timePeriodInitialized
      );
    },
    workloadUser: function() {
      return this.asurite ? this.asurite : this.user.userId;
    },
  },

  watch: {
    callsCompleted: function() {
      if (this.callsCompleted) {
        this.populatePreviousWorkload();
        this.populateCoursesFromLastWorkload(this.workload.asuriteId);
      }
    },
  },

  methods: {
    ...mapActions("workloadForm", [
      "getWorkloadTypeDefinitions",
      "initializeWorkloadTypes",
      "getYearTerms",
      "addWorkload",
      "populateCoursesFromLastWorkload",
      "populateFacultyWorkload",
      "populateFromLastWorkload",
      "getEmployeeJobs",
      "sendWorkloadSubmittedEmail",
      "sendWorkloadSubmittedBehalfEmail",
    ]),
    ...mapMutations("workloadForm", ["updateWorkloadEmployee"]),
    ...mapActions("status", ["getCurrentTimePeriod"]),

    submitWorkload: function() {
      var that = this;

      this.addWorkload()
        .then(function(response) {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("Workload was submitted.", "Success");

          if (that.$route.name === "workloadAddBehalf") {
            that.sendWorkloadSubmittedBehalfEmail(response.data.workloadId);
          } else {
            that.sendWorkloadSubmittedEmail(response.data.workloadId);
          }

          // redirect
          that.$router.push({ name: "dashboard" });
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    populatePreviousWorkload: function() {
      this.populateFromLastWorkload({
        asuriteId: this.workload.asuriteId,
        submittingOnBehalf: this.submittingOnBehalf,
        timePeriodId: parseInt(this.$route.query.timePeriod),
      }).catch(function(error) {
        console.log(error);
      });
    },

    addFile(file) {
      this.files.push(file);
    },

    removeFile(file) {},
  },

  created() {
    var that = this;

    if (this.asurite) {
      this.updateWorkloadEmployee(this.asurite);
    } else {
      this.updateWorkloadEmployee(this.user.userId);
    }

    if (this.$route.query.timePeriod) {
      TimePeriodApi.getTimePeriodById(this.$route.query.timePeriod).then(
        (response) => {
          this.$store.commit(
            "workloadForm/updateWorkloadTimePeriod",
            response.data
          );
        }
      );
      this.timePeriodInitialized = true;
    } else {
      this.getCurrentTimePeriod().then(function() {
        that.$store.commit(
          "workloadForm/updateWorkloadTimePeriod",
          that.currentTimePeriod
        );
        that.timePeriodInitialized = true;
      });
    }

    this.getWorkloadTypeDefinitions()
      .then(function() {
        that
          .initializeWorkloadTypes()
          .then(function() {
            that.workloadTypeDefinitionsInitialized = true;
          })
          .catch(function(error) {
            console.log(error);
          });
      })
      .catch(function(error) {
        console.log(error);
      });

    this.getEmployeeJobs(this.workloadUser)
      .then(function() {
        that.employeeJobsInitialized = true;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}
</style>
